import { INotification, NotificationType } from "../contexts/NotificationContext";
import Container from "./Container";
import Text from "./Text";

interface IAlertProps {
    notification: INotification;
}

const Alert = ({ notification }: IAlertProps) => {
    const getNotificationConfig = (type: NotificationType) => {
        const configs = {
            [NotificationType.default]: {
                bgClass: "bg-50",
                borderClass: "border-left-3 border-300",
                iconClass: "pi-info-circle",
                iconColor: "text-600"
            },
            [NotificationType.success]: {
                bgClass: "bg-green-50",
                borderClass: "border-left-3 border-green-500",
                iconClass: "pi-check-circle",
                iconColor: "text-green-600"
            },
            [NotificationType.error]: {
                bgClass: "bg-red-50",
                borderClass: "border-left-3 border-red-500",
                iconClass: "pi-times-circle",
                iconColor: "text-red-600"
            },
            [NotificationType.info]: {
                bgClass: "bg-blue-50",
                borderClass: "border-left-3 border-blue-500",
                iconClass: "pi-info-circle",
                iconColor: "text-blue-600"
            },
            [NotificationType.warning]: {
                bgClass: "bg-yellow-50",
                borderClass: "border-left-3 border-yellow-500",
                iconClass: "pi-exclamation-triangle",
                iconColor: "text-yellow-600"
            }
        };
        return configs[type] || configs[NotificationType.default];
    };

    const config = getNotificationConfig(notification.type);

    return (
        <div 
            className={`${config.bgClass} ${config.borderClass} w-full border-round-lg p-3 shadow-1 hover:shadow-2 transition-all transition-duration-200 cursor-pointer`}
            style={{
                borderLeftWidth: '4px',
                transition: 'all 0.2s ease'
            }}
        >
            <Container gap={3} itemsCenter className="mb-2">
                <div className={`flex align-items-center justify-content-center ${config.iconColor}`} style={{ minWidth: '1.5rem' }}>
                    <i className={`pi ${config.iconClass} text-lg`}></i>
                </div>
                <div className="flex-1">
                    <Text color="900" fontWeight="semibold" size="base" className="mb-1">
                        {notification.title}
                    </Text>
                </div>
            </Container>
            
            <div className="pl-5">
                <Text color="600" fontWeight="normal" size="sm" className="line-height-3">
                    {notification.description}
                </Text>
            </div>
        </div>
    );
}

export default Alert;